"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("firebase/firestore");
/** Obtiene la coverage básica de  corporate/SIN OBRA SOCIAL (UMA)/services/active*/
async function getBasicCoverage(firestore) {
    const path = "corporate/SIN OBRA SOCIAL (UMA)/services/active";
    const coverageRef = (0, firestore_1.doc)(firestore, path);
    let coverage;
    try {
        coverage = await (0, firestore_1.getDoc)(coverageRef);
    }
    catch (err) {
        throw new Error(`${err}`);
    }
    if (coverage.exists()) {
        return coverage;
    }
}
exports.default = getBasicCoverage;
